export * from "./watchlist-advert.dto.interface";
